module.exports = __webpack_public_path__ + "img/5.44daaf45.jpg";